import { render, staticRenderFns } from "./OrdenesDeServicioPage.vue?vue&type=template&id=40dfc3fa"
import script from "./OrdenesDeServicioPage.vue?vue&type=script&lang=js"
export * from "./OrdenesDeServicioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports